const getMobileScroll = (): number => {
    const container = document.querySelector('.epn-slider__body');
    const items = document.querySelectorAll('.epn-slider__item');

    if (!container || items.length === 0) return 0;

    const containerCenter = container.scrollLeft + container.clientWidth / 2;

    let closestIndex = 0;
    let minDistance = Infinity;

    items.forEach((item, index) => {
        const el = item as HTMLElement;
        const itemCenter = el.offsetLeft + el.offsetWidth / 2;
        const distance = Math.abs(containerCenter - itemCenter);

        if (distance < minDistance) {
            minDistance = distance;
            closestIndex = index;
        }
    });

    const nextIndex = Math.min(closestIndex + 1, items.length - 1);
    const nextItem = items[nextIndex] as HTMLElement;

    const scrollTarget = nextItem.offsetLeft + nextItem.offsetWidth / 2 - container.clientWidth / 2;

    return scrollTarget - container.scrollLeft;
};

export default getMobileScroll;
